export default {
  install (Vue, options) {
    const EventBus = new Vue()

    // Event constants
    EventBus.CREATE_SNACKBAR = 'CREATE_SNACKBAR'
    EventBus.CLEAR_SNACKBAR = 'CLEAR_SNACKBAR'
    EventBus.updateSharedTitle = 'updateSharedTitle'
    Vue.prototype.$bus = EventBus
  }
}
